<div #reportContainer id="reportContainer" class="w-100 h-100 border-0"></div>
